import * as React from 'react';

// Helper hook to update rows in state one-at-a-time
export function useIndexedState<T>(initialState: T[]): [T[], (row: number, newValue: T) => void] {
  const [state, setState] = React.useState(initialState);
  return [state, (row: number, newValue: T) => {
    let newState = [...state];
    newState[row] = newValue;
    setState(newState);
  }];
}
